// src/pages/Consultation/constants/consultation.constant.js

import {
  ClipboardCheckIcon,
  VideoCameraIcon,
  DocumentTextIcon,
  UserGroupIcon,
  ChartSquareBarIcon,
  PlayIcon,
  StopIcon,
  ClockIcon,
  DocumentReportIcon,
  CashIcon,
} from "@heroicons/react/outline";
import {
  FiVideo,
  FiFileText,
  FiUsers,
  FiActivity,
  FiCalendar,
  FiDollarSign,
} from "react-icons/fi";

// ========================================
// CONSULTATION ROUTES
// ========================================
export const CONSULTATION_ROUTES = {
  // Root
  ROOT: "/consultation",
  DASHBOARD: "/consultation",

  // Session Management
  START_SESSION: "/consultation/start-session",
  SESSION_DETAILS: "/consultation/sessions/:sessionId",

  // Future routes (commented for reference)
  // ACTIVE_SESSIONS: "/consultation/active-sessions",
  // SESSION_HISTORY: "/consultation/history",
  // ANALYTICS: "/consultation/analytics",
  // REPORTS: "/consultation/reports",
  // BILLING: "/consultation/billing",
};

// ========================================
// CONSULTATION PERMISSIONS
// ========================================
export const CONSULTATION_PERMISSIONS = {
  // View Permissions
  VIEW_CONSULTATIONS: "VIEW_CONSULTATIONS",
  VIEW_ALL_BRANCH_CONSULTATIONS: "VIEW_ALL_BRANCH_CONSULTATIONS",
  VIEW_CONSULTATION_ANALYTICS: "VIEW_CONSULTATION_ANALYTICS",
  VIEW_CONSULTATION_REPORTS: "VIEW_CONSULTATION_REPORTS",

  // Session Management Permissions
  START_CONSULTATION: "START_CONSULTATION",
  END_CONSULTATION: "END_CONSULTATION",
  PAUSE_CONSULTATION: "PAUSE_CONSULTATION",
  MANAGE_CONSULTATION_SESSIONS: "MANAGE_CONSULTATION_SESSIONS",

  // Content Permissions
  ADD_CONSULTATION_NOTES: "ADD_CONSULTATION_NOTES",
  EDIT_CONSULTATION_NOTES: "EDIT_CONSULTATION_NOTES",
  DELETE_CONSULTATION_NOTES: "DELETE_CONSULTATION_NOTES",

  // Product & Service Permissions
  ADD_PRODUCTS_TO_CONSULTATION: "ADD_PRODUCTS_TO_CONSULTATION",
  CREATE_QUOTATION: "CREATE_QUOTATION",
  GENERATE_INVOICE: "GENERATE_INVOICE",

  // Admin Permissions
  MANAGE_CONSULTATION_SETTINGS: "MANAGE_CONSULTATION_SETTINGS",
  APPROVE_CONSULTATIONS: "APPROVE_CONSULTATIONS",
  ADMIN: "CONSULTATION_ADMIN",
};

// ========================================
// CONSULTATION STATUS
// ========================================
export const CONSULTATION_STATUS = {
  SCHEDULED: "scheduled",
  WAITING: "waiting",
  IN_PROGRESS: "in_progress",
  ON_HOLD: "on_hold",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  NO_SHOW: "no_show",
  FOLLOW_UP_REQUIRED: "follow_up_required",
};

// ========================================
// SESSION STATUS
// ========================================
export const SESSION_STATUS = {
  NOT_STARTED: "not_started",
  ACTIVE: "active",
  PAUSED: "paused",
  COMPLETED: "completed",
  EXPIRED: "expired",
  CANCELLED: "cancelled",
};

// ========================================
// CONSULTATION TYPES
// ========================================
export const CONSULTATION_TYPES = {
  IN_STORE: "in_store",
  VIDEO_CALL: "video_call",
  PHONE_CALL: "phone_call",
  CHAT: "chat",
  HOME_VISIT: "home_visit",
};

// ========================================
// CONSULTATION PRIORITIES
// ========================================
export const CONSULTATION_PRIORITY = {
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
  URGENT: "urgent",
};
